// extracted by mini-css-extract-plugin
export default {"container":"orderIngredientId_container__7MxK1"};